import { render, staticRenderFns } from "./detail-project-search.vue?vue&type=template&id=08ea94e5&scoped=true&"
import script from "./detail-project-search.vue?vue&type=script&lang=js&"
export * from "./detail-project-search.vue?vue&type=script&lang=js&"
import style0 from "./detail-project-search.vue?vue&type=style&index=0&id=08ea94e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea94e5",
  null
  
)

export default component.exports